module.exports = {
  __init__: [ 'moveCanvas' ],
  moveCanvas: [ 'type', require(56) ]
};